import React from 'react';

type SliderControlProps = {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  formatValue?: (value: number) => string;
};

export const SliderControl: React.FC<SliderControlProps> = ({
  label,
  value,
  min,
  max,
  step,
  onChange,
  formatValue = (v) => Math.round(v * 100) + '%'
}) => (
  <div>
    <div className="flex justify-between items-center mb-1">
      <span className="text-xs text-zinc-400">{label}</span>
      <span className="text-xs text-zinc-500">{formatValue(value)}</span>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer slider"
    />
  </div>
);